import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '@/_modules/authentication/auth.service';

export const CanActivateLogin: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.canOpenDashboard().pipe(
    map((canOpen) => (canOpen ? router.createUrlTree(['/dashboard']) : true)),
  );
};
